<script>
  import { Link } from 'svelte-navigator';
  import NavBar from '../components/NavBar.svelte';
  import LottieAnimation from '../components/LottieAnimation.svelte';

  let playSaw, pauseSaw;
  let playBloom, pauseBloom;
  let playPump, pausePump;

  const hoverSaw = () => {
    playSaw();
    pausePump();
    pauseBloom();
  };
  const hoverPump = () => {
    playPump();
    pauseSaw();
    pauseBloom();
  };
  const hoverBloom = () => {
    playBloom();
    pauseSaw();
    pausePump();
  };
  const playAll = () => {
    playSaw();
    playPump();
    playBloom();
  };
</script>

<section class="games">
  <NavBar />
  <div class="games__inner">
    <div class="games__content">
      <ul>
        <Link to="/game/bloom">
          <figure
            class="games__content--img"
            on:mouseleave={playAll}
            on:mouseenter={hoverBloom}
          >
            <LottieAnimation
              bind:play={playBloom}
              bind:pause={pauseBloom}
              path="/lotties/bloom-menu.json"
              loop={true}
            />
          </figure>
          <li class="games__content--title">BLOOM</li>
        </Link>
        <Link to="/game/saw">
          <figure
            class="games__content--img "
            on:mouseleave={playAll}
            on:mouseenter={hoverSaw}
          >
            <LottieAnimation
              bind:play={playSaw}
              bind:pause={pauseSaw}
              path="/lotties/saw-menu.json"
              loop={true}
            />
          </figure>
          <li class="games__content--title">SAW</li>
        </Link>
        <Link to="/game/pump">
          <figure
            class="games__content--img"
            on:mouseleave={playAll}
            on:mouseenter={hoverPump}
          >
            <LottieAnimation
              bind:play={playPump}
              bind:pause={pausePump}
              path="/lotties/pump-menu.json"
              loop={true}
            />
          </figure>
          <li class="games__content--title">PUMP</li>
        </Link>
      </ul>
    </div>
  </div>
</section>
